export default `/* Ids Widget Component */
:host .flex-content,
:host ::slotted(.flex-content) {
  display: flex;
  align-items: center;
  padding: var(--ids-widget-padding-inline);
  gap: var(--ids-space-sm);
}

.ids-widget {
  background-color: var(--ids-widget-color-background);
  border: 1px solid var(--ids-widget-color-border);
  border-radius: var(--ids-widget-border-radius);
  box-shadow: var(--ids-widget-shadow);
  margin-block-end: var(--ids-widget-margin-bottom);
  height: var(--ids-widget-height);
  transition: box-shadow var(--ids-motion-duration) var(--ids-motion-linear);
  overflow: hidden;
}
.ids-widget .ids-widget-content {
  box-sizing: border-box;
  height: var(--ids-widget-content-height);
  overflow: auto;
  width: 100%;
  position: relative;
}
.ids-widget .ids-widget-content.overflow-hidden {
  overflow: hidden;
}
.ids-widget .ids-widget-content.is-scrolling {
  box-shadow: var(--ids-scroll-shadow);
  border-top: var(--ids-scroll-color-border-top);
}
.ids-widget .ids-widget-content.has-search {
  height: var(--ids-widget-search-content-height);
}
.ids-widget .ids-widget-content.has-subtitle {
  height: var(--ids-widget-search-subtitle-content-height);
  margin-top: -4px;
  overflow: visible;
}
.ids-widget .hidden {
  display: none;
}
.ids-widget:hover {
  outline: 1px solid var(--ids-widget-color-border-hover);
  box-shadow: var(--ids-widget-color-shadow-hover);
}
.ids-widget {
  --ids-search-field-color-border-default: var(--ids-widget-search-field-color-background);
  --ids-search-field-color-background-default: var(--ids-widget-search-field-color-background);
  --ids-search-field-margin: 0px var(--ids-space-xs);
  --ids-search-field-border-radius: var(--ids-widget-search-field-border-radius);
  --ids-list-view-height: 264px;
}

:host([borderless]) .ids-widget {
  background-color: var(--ids-color-transparent);
  box-shadow: none;
  border: 1px solid transparent;
}
:host([borderless]) .ids-widget .ids-widget-content {
  border-radius: var(--ids-widget-border-radius);
}
:host([borderless]) .ids-widget:hover {
  outline: 1px solid transparent;
  box-shadow: none;
}

.ids-widget-body {
  width: 100%;
}

.ids-widget-header {
  align-items: center;
  color: var(--ids-widget-header-title-color);
  display: flex;
  padding-inline-start: var(--ids-widget-header-padding-inline);
  height: var(--ids-widget-header-height);
}
.ids-widget-header.has-subtitle {
  height: var(--ids-widget-header-subtitle-height);
}
.ids-widget-header.is-empty {
  height: 0;
  padding-inline-start: 0;
}

::slotted([slot=widget-actions]) {
  position: absolute;
  margin-inline-start: var(--ids-widget-actions-margin-inline-start);
  margin-top: 15px;
}

::slotted([slot=widget-header]) {
  position: relative;
  width: 100%;
}

::slotted([slot=widget-search]) {
  height: var(--ids-widget-search-height);
}

.ids-widget-footer {
  display: none;
  border-top: 1px solid var(--ids-widget-divider-color-border);
  width: 100%;
  padding: var(--ids-space-xs) 0;
}

.has-footer .ids-widget-footer {
  display: block;
}
.has-footer .ids-widget-content {
  --ids-widget-height: 250px;
  --ids-widget-content-height: 260px;
  --ids-list-view-height: 254px;
}

:host([size=quarter]) .ids-widget {
  --ids-widget-height: var(--ids-widget-size-quarter-height);
  box-sizing: border-box;
  width: var(--ids-widget-size-quarter-width);
}

:host([size=half]) .ids-widget {
  --ids-widget-height: var(--ids-widget-size-half-height);
  --ids-kpi-width: calc(var(--ids-widget-size-half-width) - 33px);
  --ids-widget-actions-margin-inline-start: var(--ids-widget-actions-size-half-margin-inline-start);
  box-sizing: border-box;
  width: var(--ids-widget-size-half-width);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
